import { CartStore } from "../../global/store/CartStore";

export const checkIfProdIsPackage = (cart: CartStore, product: AppCartProduct) => {
    // const isNotPackage = (cart.CartonPackage || cart.Package || cart.CartonPackagePizza) && ((cart.Package && product.Data.PulseCode == cart.Package.Id) || ( cart.CartonPackage && product.Data.PulseCode == cart.CartonPackage.Id) || ( cart.CartonPackagePizza && product.Data.PulseCode == cart.CartonPackagePizza.Id));
    if (cart.Packages.length ) {
        const PackagesIds = cart.Packages.some(pack => product.Data.PulseCode === pack.Id);
        const isNotPackage = cart.Packages && PackagesIds;
        return isNotPackage
    } 
}